import { IResources } from '../../../../../Types';

export const ReportsTableColumns = (resources:IResources) => [
    {
        dataField: 'serialNumber',
        text: resources.Pack,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '40%'
        }
    },
    {
        dataField: 'productName',
        text: resources.ProductName,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    },
    {
        dataField: 'expiryDate',
        text: 'product Expiry Date',
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '22%'
        }
    },
    { 
        dataField: 'batchId',
        text: 'batch Id',
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    },
     {
        dataField: 'submissionTime',
        text: resources.SubmissionTime,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '35%'
        }
    }, {
        dataField: 'action',
        text: resources.Action,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '23%'
        }
    }, {
        dataField: 'RAG',
        text: resources.RAG,
        sort: false,
        style: {
            verticalAlign: 'middle'
        }
        ,
        headerStyle: {
            textAlign: 'center',
            width: '12%'
        }
    }, {
        dataField: 'UPRC',
        text: resources.UPRC,
        sort: false,
        style: {
            verticalAlign: 'middle'
        }
        ,
        headerStyle: {
            textAlign: 'center',
            width: '10%'
        }
    }
];